<template>
  <div class="login">
    <b>绑定手机号</b>
    <div class="inp">
      <div class="phone">
        <div class="security-code" @click="chooseCountryClick">
          +{{ areaCode }}
          <img src="../../assets/images/jt6.png" />
        </div>
        <label for="code" style="flex: 1;">
          <ul class="security-code-container">
            <li v-if="value !== ''" class="field-wrap" v-for="(item, index) in number" :key="index">
              <i class="char-field">{{ value[index] }}</i>
            </li>
            <li
              v-if="value == ''"
              class="field-wrap"
              v-for="(item, index) in defaultText"
              :key="index"
            >
              <i class="char-field char-default">{{ item }}</i>
            </li>
            <li class="close" v-if="closeTel" @click="handleClick">
              <img src="../../assets/images/close.png" style=" width:0.13rem; height:0.13rem;" />
            </li>
          </ul>
        </label>
      </div>
      <input
        ref="input"
        class="input-code"
        @keyup="handleInput"
        v-model="value"
        :placeholder="defaultText"
        id="code"
        name="code"
        type="tel"
        :maxlength="number"
        autocorrect="off"
        autocomplete="off"
        autocapitalize="off"
      />
    </div>
    <div class="codeWrap">
      <div class="inputWrap">
        <input placeholder="图形验证码" v-model="codeValue" @keyup="codeChange" />
        <img class="close" src="../../assets/images/close.png" v-if="CodeFlag" @click="clearCode" />
      </div>
      <div class="codeImg" ref="codeImg" @click="code">
        <img :src="codeImg" />
      </div>
    </div>
    <button class="gain" :class="passFlag ? 'gainRed' : ''" @click="codeClick">获取验证码</button>
    <div
      style="display: flex;
        display: -o-flex;
        display: -ms-flex;
        display:-moz-flex;
        display:-webkit-flex;
    "
    >
      <van-checkbox v-model="checked" checked-color="#FC0324" icon-size="14">
        <p class="agreement">点击登录表示已阅读并同意</p>
      </van-checkbox>
      <p class="agreement" @click="agreement"><span>《用户协议》</span></p>
    </div>
  </div>
</template>

<script>
import { basepath, encryption, unencryption, random_string } from '../../assets/common/js/config'

export default {
  name: 'loginIn',
  data() {
    return {
      value: '',
      number: 11,
      closeTel: false,
      defaultText: '手机号',
      checked: true,
      areaCode: '86',
      codeValue: '',
      CodeFlag: false,
      codeImg: '',
      passFlag: false,
      timeout: null
    }
  },
  watch: {
    value(n) {
      this.$nextTick(() => {
        //这里
        this.value = String(n).replace(/\D/g, '')
      })
    },
    codeValue() {
      this.codeChange()
    }
  },
  mounted: function () {
    if (this.$route.query.isagree == 1) {
      this.checked = true
    } else if (this.$route.query.isagree == 2) {
      this.checked = false
    }
    if (sessionStorage.getItem('ckys_wx_bound_tel')) {
      this.closeTel = true
      this.value = unencryption(sessionStorage.getItem('ckys_wx_bound_tel'))
    }
    if (this.$route.query.area_code) {
      this.areaCode = this.$route.query.area_code
    } else if (sessionStorage.getItem('ckys_wx_bound_area_code')) {
      this.areaCode = sessionStorage.getItem('ckys_wx_bound_area_code')
    }
    this.code()
  },
  destroyed: function () {
    this.$toast.clear()
    this.$dialog.close()
  },
  methods: {
    code: function() {
      var width = this.$refs.codeImg.clientWidth
      var height = this.$refs.codeImg.clientHeight
      this.timeout = new Date().getTime() + '' + random_string(16)
      this.codeImg = this.$ajax.getValidateCode_URL(
        'sessionid=' + this.timeout + '&width=' + width + '&height=' + height
      )
    },
    hideKeyboard: function() {
      // 输入完成隐藏键盘
      document.activeElement.blur() // ios隐藏键盘
      this.$refs.input.blur() // android隐藏键盘
    },
    handleClick: function () {
      this.value = ''
      this.closeTel = false
      this.checkInfo()
    },
    clearCode: function () {
      this.codeValue = ''
      this.CodeFlag = false
      this.checkInfo()
    },
    codeChange: function () {
      this.CodeFlag = this.codeValue ? true : false
      this.checkInfo()
    },
    handleInput: function () {
      this.$refs.input.value = this.value
      if (this.value.length >= this.number) {
        this.hideKeyboard()
      }
      if (this.value.length <= 0) {
        this.closeTel = false
      } else {
        this.closeTel = true
      }
      this.checkInfo()
    },
    checkInfo: function () {
      this.passFlag = this.value.length >= this.number && this.codeValue.length >= 4 ? true : false
    },
    checkPhone: function () {
      if (!/^1[3456789]\d{9}$/.test(this.value)) {
        return false
      } else {
        if (!this.checked) {
          return false
        } else {
          return true
        }
      }
    },
    codeClick: function () {
      if (!this.passFlag) {
        return
      }
      if (this.checkPhone()) {
        var url =
          this.$ajax.getValidCode_URL +
          '?newVersion=1&mobile=' +
          this.value +
          '&code=' +
          this.codeValue +
          '&sessionid=' +
          this.timeout +
          '&type=2&area_code=' +
          this.areaCode
        var that = this
        that.$toast.loading({
          mask: true,
          message: '加载中...',
          duration: 0
        })
        that.$customRequestAjax(url).then((res) => {
          if (res.data.code === 200) {
            if (that.value != '') {
              sessionStorage.setItem('ckys_wx_bound_tel', encryption(that.value))
            } else if (that.value == '') {
              sessionStorage.setItem('ckys_wx_bound_tel', that.value)
            }
            sessionStorage.setItem('ckys_wx_bound_area_code', that.areaCode)
            that.$toast.clear()
            that.$router.replace('/boundcode')
          } else if (res.data.code == '10011') {
            that.clearCode()
            that.code()
          }
        })
      }
    },
    chooseCountryClick: function () {
      if (this.value != '') {
        sessionStorage.setItem('ckys_wx_bound_tel', encryption(this.value))
      } else if (this.value == '') {
        sessionStorage.setItem('ckys_wx_bound_tel', this.value)
      }
      this.$router.replace('/boundcountry')
    },
    agreement: function () {
      if (this.value != '') {
        sessionStorage.setItem('ckys_wx_bound_tel', encryption(this.value))
      } else if (this.value == '') {
        sessionStorage.setItem('ckys_wx_bound_tel', this.value)
      }
      sessionStorage.setItem('ckys_wx_bound_area_code', this.areaCode)
      this.$router.replace({
        path: '/agreement',
        query: {
          type: 'bound'
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
// @import '../../assets/common/css/code.scss';
.login {
  min-height: 100%;
  padding: 0 0.3rem;
  background: #fff;
  b {
    margin-top: 0.62rem;
    margin-bottom: 0.53rem;
    display: block;
    font-size: 0.29rem;
    font-weight: 600;
    color: rgba(51, 51, 51, 1);
    line-height: 0.41rem;
  }
  p {
    margin-top: 0.03rem;
    margin-bottom: 0.53rem;
    font-size: 0.14rem;
    font-weight: 400;
    color: rgba(136, 136, 136, 1);
    line-height: 0.2rem;
  }
  .phone {
    display: flex;
    display: -webkit-flex;
    display: -moz-flex;
    display: -ms-flex;
    display: -o-flex;
    justify-content: center;
    -webkit-justify-content: center;
    -moz-justify-content: center;
    -ms-justify-content: center;
    -o-justify-content: center;
    .security-code {
      display: flex;
      display: -webkit-flex;
      display: -moz-flex;
      display: -ms-flex;
      display: -o-flex;
      align-items: center;
      -webkit-align-items: center;
      -moz-align-items: center;
      -ms-align-items: center;
      -o-align-items: center;
      font-size: 0.16rem;
      height: 0.44rem;
      line-height: 0.44rem;
      /*margin-right: 0.15rem;*/
      /*border-bottom: 1px solid #5F6274;*/
      background: #f7f7f7;
      -webkit-border-radius: 0.22rem 0 0 0.22rem;
      -moz-border-radius: 0.22rem 0 0 0.22rem;
      border-radius: 0.22rem 0 0 0.22rem;
      padding-left: 0.15rem;
      padding-right: 0.1rem;
      img {
        width: 0.16rem;
        height: 0.16rem;
        padding: 0.06rem 0.05rem 0.06rem 0.03rem;
      }
    }
    .security-code-container {
      margin: 0;
      padding: 0;
      display: flex;
      display: -webkit-flex;
      display: -moz-flex;
      display: -ms-flex;
      display: -o-flex;
      justify-content: flex-start;
      -webkit-justify-content: flex-start;
      -moz-justify-content: flex-start;
      -ms-justify-content: flex-start;
      -o-justify-content: flex-start;
      height: 0.44rem;
      line-height: 0.44rem;
      background: #f7f7f7;
      -webkit-border-radius: 0.22rem 0 0 0.22rem;
      -moz-border-radius: 0.22rem 0 0 0.22rem;
      border-radius: 0 0.22rem 0.22rem 0;
      position: relative;
      .close {
        margin: 0.15rem 0.09rem;
        position: absolute;
        right: 0;
        top: 0;
      }
      .field-wrap {
        list-style: none;
        display: block;
        /*width: 0.4rem;*/
        height: 0.22rem;
        line-height: 0.22rem;
        font-size: 0.16rem;
        /*background-color: #fff;*/
        margin: 0.11rem 0;
        text-align: center;
        color: #000;
        .char-field {
          font-style: normal;
          &.char-default {
            color: #999999;
          }
        }
      }
    }
  }
  .input-code {
    opacity: 0;
    position: absolute;
    left: -999px;
    width: 100%;
    height: 0.1rem;
  }
  .gain {
    width: 100%;
    background: linear-gradient(90deg, rgba(252, 3, 36, 1) 0%, rgba(246, 58, 102, 1) 100%);
    background: -webkit-linear-gradient(90deg, rgba(252, 3, 36, 1) 0%, rgba(246, 58, 102, 1) 100%);
    background: -moz-linear-gradient(90deg, rgba(252, 3, 36, 1) 0%, rgba(246, 58, 102, 1) 100%);
    background: -ms-linear-gradient(90deg, rgba(252, 3, 36, 1) 0%, rgba(246, 58, 102, 1) 100%);
    background: -o-linear-gradient(90deg, rgba(252, 3, 36, 1) 0%, rgba(246, 58, 102, 1) 100%);
    border-radius: 0.25rem;
    opacity: 0.39;
    font-size: 0.17rem;
    font-weight: 400;
    color: rgba(254, 254, 254, 1);
    line-height: 0.24rem;
    display: block;
    border: none;
    outline: none;
    padding: 0.1rem 0;
    margin-top: 0.27rem;
    margin-bottom: 0.17rem;
    &.gainRed {
      opacity: 1;
    }
  }
  .agreement {
    margin: 0;
    font-size: 0.12rem;
    font-weight: 400;
    color: rgba(166, 166, 166, 1);
    line-height: 0.17rem;
    span {
      color: #4a90e2;
    }
  }
  .codeWrap {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 0.15rem;
    .inputWrap {
      flex: 1 1 0%;
      position: relative;
      border-radius: 0.22rem;
      padding-left: 0.15rem;
      height: 0.44rem;
      line-height: 0.44rem;
      background: #f7f7f7;
      font-size: 0.16rem;
      color: #000;
      input {
        background: none;
        outline: none;
        border: none;
      }
      img {
        width: 0.13rem;
        height: 0.13rem;
        position: absolute;
        top: 0;
        right: 0;
        margin: 0.15rem 0.09rem;
      }
    }
    .codeImg {
      height: 0.36rem;
      width: 34.5%;
      background: rgb(238, 238, 238);
      margin-left: 0.1rem;
      overflow: hidden;
    }
  }
}
</style>
<style lang="scss">
.login {
  .van-checkbox {
    overflow: visible;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/phone/boundPhone.vue